const params = new URLSearchParams(window.location.search);

export const API_URL = params.get('API_URL') || 'https://api.quadible.io';
export const SIGNING_KEY =
  params.get('SIGNING_KEY') || '39c6a0010765f31bf3baad9ec02d541ed3359e86';
export const ORG_ID = params.get('ORG_ID') || '686257f8de51aea98348cd43';
export const EXTERNAL_USER_ID = params.get('EXTERNAL_USER_ID') || '';
export const ADMIN_KEY = params.get('ADMIN_KEY') || '';
